/**
 * Form to input parameters and constraints based on which test cases are generated in the ctd tool
 * @param {boolean} isLab
 * @param {object} parameters
 * @param {function} setParameters
 * @param {object} generatedTests
 * @param {function} generateFunction
 * @param {boolean} generateDisable default 'false', turns 'true' when tool is used as part of lab and the parameters are not valid
 */
import Styles from './GeneratedTests.module.scss';
import React from 'react'

// component imports
import { useTranslation } from 'components/lib';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import FeatherIcon from 'feather-icons-react';

export function GeneratedTests({ isLab, generatedTests, parameters, setParameters, generateFunction, generateDisable }) {

    const { t } = useTranslation();

    function downloadTestCases() {
        //function allows to download the generated test cases in csv format
        const csvContent = `data:text/csv;charset=utf-8,${generatedTests.headers.join(',')}\n${generatedTests.cases.map(row => row.join(',')).join('\n')}`
        const encodedUri = encodeURI(csvContent);
        const downloadLink = document.createElement('a');
        downloadLink.setAttribute('href', encodedUri);
        downloadLink.setAttribute('download', 'data.csv')
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    function selectCombination(e) {
        //function allows you to select the coverage - 1-wise, 2-wise, 3-wise
        setParameters(prevState => ({
            ...prevState,
            coverage: e.target.value
        }))
    }

    return (
        <div className={Styles.parentContainer_results}>

            <div className={Styles.header}>
                <p>{t('Components.NodeLayout.CombinatorialTestPane.generatedTests.header')}</p>
                <span style={{ display: 'flex', gap: '1em' }}>
                    <select
                        onChange={selectCombination}
                        value={parameters.coverage}
                        className={Styles.selectCoverage}
                    >
                        <option>n-wise</option>
                        <option value={1}>1 wise</option>
                        <option value={2}>2 wise</option>
                        <option value={3}>3 wise</option>
                    </select>
                    <AivagamButton
                        buttonText={
                            <div style={{ display: 'flex', gap: '0.5em', height: '1em', alignItems: 'center' }}>
                                {t('Components.NodeLayout.CombinatorialTestPane.generatedTests.button.generateTests')}
                            </div>
                        }
                        onClick={generateFunction}
                        disabled={generateDisable}
                    />
                    <AivagamButton
                        buttonText={
                            <div style={{ display: 'flex', gap: '0.5em', height: '1em', alignItems: 'center' }}>
                                <FeatherIcon size='1.5em' icon='save' />
                                {t('Components.NodeLayout.CombinatorialTestPane.generatedTests.button.saveTests')}
                            </div>
                        }
                        disabled={!generatedTests}
                        onClick={downloadTestCases}
                        classStyles={{ height: 'fit-content', display: isLab && 'none' }}
                        type='confirm'
                    />
                </span>
            </div>
            <div className={Styles.results_body}>
                {
                    generatedTests ?
                        <>
                            <table className={Styles.test_table}>
                                <thead>
                                    <tr>
                                        <th></th>
                                        {
                                            generatedTests.headers.map((header) => (
                                                <th key={header}>{header}</th>
                                            ))
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {generatedTests.cases.map((rows, index) => (
                                        <tr key={`${index}_${rows[0]}`}>
                                            <td style={{ fontWeight: 600 }}>{index + 1}</td>
                                            {
                                                rows.map((item, itemIndex) => {
                                                    return <td key={`${item}_${index}_${itemIndex}`}>{item}</td>
                                                })
                                            }
                                        </tr>
                                    ))}
                                    <tr></tr>
                                </tbody>
                            </table>
                        </>
                        : <p className={Styles.warningText}><span style={{ color: 'red', marginRight: '0.2em' }}>*</span>{t('Components.NodeLayout.CombinatorialTestPane.generatedTests.alert.desiredParams')}</p>
                }
            </div>
        </div>
    )
}
